import appLogger from "../utils/app-logger";
import { apiService } from "./base-api-service";
import { endPoints, getDashboardOrchestrationServiceEndPoint } from "./api-constants";
import { getAuthHeader, readCookie } from "../utils/helpers";

class DashboardOrchestrationService {
  DashboardOrchestrationService(url) {
    return getDashboardOrchestrationServiceEndPoint(url);
  }

  getPSSSBillingInfo(userGuid, locale) {
    // PdfSimpli , SignSimpli
    appLogger.log("inside getBillingInfo ");
    const billingInfoEndpoint = this.DashboardOrchestrationService(
      `${endPoints.dashboardOrchestrationService.BILLING_INFO.replace(":userGuid", userGuid).replace(
        ":locale",
        locale,
      )}`,
    );
    return apiService.get(billingInfoEndpoint, null, getAuthHeader());
  }

  getAllDocumentsByUserGuid(userGuid) {
    // PdfSimpli , SignSimpli
    appLogger.log("inside getAllDocumentsByUserGuid ");
    const endpoint = this.DashboardOrchestrationService(
      `${endPoints.dashboardOrchestrationService.GET_ALL_DOCUMENTS.replace(":userGuid", userGuid)}`,
    );
    return apiService.get(endpoint, null, getAuthHeader());
  }

  convertDocument(data) {
    const convertDocumentEndPoint = this.DashboardOrchestrationService(
      `${endPoints.dashboardOrchestrationService.CONVERT_DOC}`,
    );
    return apiService.post(convertDocumentEndPoint, data, getAuthHeader());
  }
  CompleteProcessDocument(jobId, docId, itemType = "", fileType = "") {
    const dashsoardEndPoint = this.DashboardOrchestrationService(
      `${endPoints.dashboardOrchestrationService.COMPLETE_DOC.replace(":jobId", jobId)
        .replace(":docId", docId)
        .replace(":itemType", itemType)
        .replace(":fileType", fileType)}`,
    );
    return apiService.put(dashsoardEndPoint, "", getAuthHeader());
  }
  generateSasUriTokenForContainer(hoursExpiry) {
    const sasTokenEndPoint = endPoints.dashboardOrchestrationService.SAS_TOKEN;
    const getServiceEndpoint = this.DashboardOrchestrationService(
      `${sasTokenEndPoint.replace(":expiryHours", hoursExpiry)}`,
    );
    return apiService.get(getServiceEndpoint, null, getAuthHeader());
  }

  getPdfUrl(data) {
    const convertDocumentEndPoint = this.DashboardOrchestrationService(
      `${endPoints.dashboardOrchestrationService.TRANSCRIPTION_DOWNLOAD}`,
    );
    return apiService.post(convertDocumentEndPoint, data, getAuthHeader());
  }
  getPdfUrlZip(data) {
    const convertDocumentEndPoint = this.DashboardOrchestrationService(
      `${endPoints.dashboardOrchestrationService.PROCESS_TRANSCRIPTION_DOCUMENT}`,
    );
    return apiService.post(convertDocumentEndPoint, data, getAuthHeader());
  }
  shareOrEmailDocuments(request) {
    const jwtToken = readCookie("jwtToken");
    const headers = { Authorization: "Bearer " + jwtToken };
    const shareOrEmailEndPoint = this.DashboardOrchestrationService(
      `${endPoints.dashboardOrchestrationService.SHARE_OR_EMAIL}`,
    );
    return apiService.post(shareOrEmailEndPoint, request, headers);
  }
  uploadDocs(data) {
    const jwtToken = readCookie("jwtToken");
    const headers = {
      "content-type": "application/json",
      Authorization: "Bearer" + " " + jwtToken,
    };
    const uploadDocumentEndpoint = this.DashboardOrchestrationService(
      `${endPoints.dashboardOrchestrationService.UPLOAD_DOCS}`,
    );
    return apiService.post(uploadDocumentEndpoint, data, headers);
  }

  getDocList(searchObject) {
    const jwtToken = readCookie("jwtToken");
    const headers = { Authorization: "Bearer" + " " + jwtToken };
    const getDocListByUserGuidEndpoint = this.DashboardOrchestrationService(
      `${endPoints.dashboardOrchestrationService.GET_DOCUMENTS}`,
    );
    return apiService.post(getDocListByUserGuidEndpoint, searchObject, headers);
  }

  ImageOperation(data) {
    const getDocListByUserGuidEndpoint = this.DashboardOrchestrationService(
      `${endPoints.dashboardOrchestrationService.IMAGE_PROCESS}`,
    );
    return apiService.put(getDocListByUserGuidEndpoint, data, getAuthHeader());
  }
  updateDocumentAction(data) {
    const jwtToken = readCookie("jwtToken");
    const headers = {
      Authorization: "Bearer" + " " + jwtToken,
    };
    const updateDocumentEndPoint = this.DashboardOrchestrationService(
      `${endPoints.dashboardOrchestrationService.UPDATE_DOCUMENT_ACTION}`,
    );
    return apiService.put(updateDocumentEndPoint, data, headers);
  }
  operationLimit(data) {
    const jwtToken = readCookie("jwtToken");
    const headers = { Authorization: "Bearer" + " " + jwtToken };
    const getOperationLimitEndpoint = this.DashboardOrchestrationService(
      `${endPoints.dashboardOrchestrationService.OPERATION_LIMIT}`
    );
    return apiService.post(getOperationLimitEndpoint, data, headers);
  }

    sendShareEmails(data) {
      const endpoint = this.DashboardOrchestrationService(
      `${endPoints.dashboardOrchestrationService.SEND_SHARE_EMAILS}`,
    );
    return apiService.post(endpoint, data, getAuthHeader());
  }
  operationLimit(data) {
    const jwtToken = readCookie("jwtToken");
    const headers = { Authorization: "Bearer" + " " + jwtToken };
    const getOperationLimitEndpoint = this.DashboardOrchestrationService(
      `${endPoints.dashboardOrchestrationService.OPERATION_LIMIT}`
    );
    return apiService.post(getOperationLimitEndpoint, data, headers);
  }

}

export default new DashboardOrchestrationService();
